import { Component } from '@angular/core';

@Component({
  selector: 'phc-user-cash-image-component',
  templateUrl: './user-cash.component.html',
  styleUrls: ['./user-cash.component.scss']
})
export class UserCashComponent  {

  

}
